<script lang="typescript">

    export let updatedAt: number;
    export let name: string;
    export let id: string;
    import Fa from 'svelte-fa'
    // import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
    import { faFileAlt } from '@fortawesome/free-regular-svg-icons'

</script>

<div title={`'${name}' last edited on ${new Date(updatedAt).toDateString()}`} class="offerItem" >
    <Fa icon={faFileAlt} size="6x" swapOpacity={false}/>
    <p class="offerTitle">{name}</p>
</div>

<style>
.offerItem{
    display: flex; 
    margin-bottom: 0.5rem; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    /* padding-top: 10px;
    padding-bottom: 10px; */
    width: fit-content;
}

.offerTitle{
    text-align: center;
    max-width: 100%;
}
</style>